import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import { SkeletonLoader } from "@twilio-paste/core/skeleton-loader";
import { Stack } from "@twilio-paste/core/stack";

const CsatSurveySkeletonLoader = (): ReactElement => {
  return (
    <Box as="section">
      <Stack orientation="vertical" spacing="space20">
        <SkeletonLoader width="90%" />
        <SkeletonLoader width="30%" />
      </Stack>
      <Box as="div" marginTop="space40">
        <Stack orientation="vertical" spacing="space40">
          <SkeletonLoader width="25%" />
          <SkeletonLoader width="20%" />
          <SkeletonLoader width="40%" />
          <SkeletonLoader width="20%" />
          <SkeletonLoader width="25%" />
        </Stack>
      </Box>
      <Box as="div" marginTop="space60">
        <Stack orientation="vertical" spacing="space20">
          <SkeletonLoader width="90%" />
          <SkeletonLoader width="100%" height="100px" />
        </Stack>
      </Box>
      <Box
        as="div"
        display="flex"
        justifyContent="space-between"
        marginBottom="space30"
        marginTop="space60"
      >
        <SkeletonLoader width="75px" height="36px" />
        <SkeletonLoader width="140px" height="36px" />
      </Box>
    </Box>
  );
};

export default CsatSurveySkeletonLoader;
